import { Button, Col, Divider, Flex, Form, Input, Row, Switch, Table, Upload, message } from 'antd'
import React from 'react'
import VotingEnd from './VotingEnd'
import { InboxOutlined, DeleteOutlined, CheckOutlined, EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import MyVote from './MyVote';

const { TextArea } = Input;

const { Dragger } = Upload;
const props = {
    name: 'file',
    multiple: true,
    action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    onChange(info) {
        const { status } = info.file;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    },
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
    },
};

const dataSource = [
    {
        key: '1',
        attachementName: 'Attachement 1',
        date: '2024-12-12',
        action: "",
        description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
    },
    {
        key: '2',
        attachementName: 'Attachement 1',
        date: '2024-12-12',
        action: "",
        description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
    },
    {
        key: '2',
        attachementName: 'Attachement 1',
        date: '2024-12-12',
        action: "",
        description: " Ad fugiat culpa non amet laborum irure eu. Et laboris Lorem culpa ut duis minim duis sint. Minim magna ad qui voluptate non excepteur ex ipsum irure dolore voluptate est. Sit laborum dolor excepteur ex do. Non officia tempor ipsum aute deserunt in. Nisi do non culpa veniam consequat sint labore id laborum ad sunt."
    },
];

const columns = [
    {
        title: 'Attachment Name',
        dataIndex: 'attachementName',
        key: 'attachementName',
    },
    {
        title: 'Created',
        dataIndex: 'date',
        key: 'date',
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        align: 'center',
        render: (_, record) => (
            <Flex gap="small" justify="center" align="center" vertical>
                <Flex gap="middle" wrap="wrap">
                    <Button icon={<EyeOutlined />} size='small' />
                    <Button type="primary" icon={<DownloadOutlined />} size='small' />
                    {/* <Button type="primary" icon={<EditOutlined />} size='small' /> */}
                    <Button danger type="primary" icon={<DeleteOutlined />} size='small' />
                </Flex>
            </Flex>
        ),
    }
];

export default function AgendaItemVoting() {
    return (
        <Form layout="vertical">
            <Col span={24}>
                <Form.Item label="Agenda Item">
                    <Input />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item label="Description">
                    <TextArea />
                </Form.Item>
            </Col>
            <Col span={24}>
                        <Table
                            dataSource={dataSource}
                            columns={columns}
                            title={() => 'Added Documents'}
                        />
                    </Col>


            <Col span={24}>
                <Form.Item >
                    <div>
                        <Row>
                            <Col span={12}>
                                <Form.Item label="My Vote">
                                    <MyVote />
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                </Form.Item>
            </Col>
        </Form>
    )
}
